import React, { Component } from "react";
import { useNavigate } from 'react-router-dom';
import { Button, Divider, Link, Menu, MenuItem } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { Launch } from '@mui/icons-material';

import './MobileMenu.css';
import matchLogo from '../assets/logo.png';


const FirmProspectsMenuItem = (props) => {
  return (
    <MenuItem><Link href="https://www.firmprospects.com" className="logobar-link" target="_blank" rel="noreferrer" underline="none">Firm Prospects <Launch/></Link></MenuItem>
  )
}

const WebsiteMenuItem = (props) => {
  return (
    <MenuItem><Link href="https://www.lateral-match.com" className="logobar-link" target="_blank" rel="noreferrer" underline="none">www.lateral-match.com <Launch/></Link></MenuItem>
  )
}

const MyAccountMenuItem = (props) => {
  const navigate = useNavigate();
  return (
    <MenuItem onClick={(e)=> props.onClick(e, navigate)} variant="outlined">My Account</MenuItem>
  )
}

const ChangePasswordMenuItem = (props) => {
  const navigate = useNavigate();
  return (
    <MenuItem onClick={(e)=> props.onClick(e, navigate)} variant="outlined">Change Password</MenuItem>
  )
}

const LogoutMenuItem = (props) => {
  const navigate = useNavigate();
  return (
    <MenuItem onClick={(e)=> props.onClick(e, navigate)} variant="outlined">Logout {props.name}</MenuItem>
  )
}

const defaultState = {
  anchorEl: null,
  open: false,
};

export default class MobileMenu extends Component {

  constructor() {
    super();
    this.state = defaultState;
    this.logout = this.logout.bind(this);
    this.onMyAccount = this.onMyAccount.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.openActionsMenu = this.openActionsMenu.bind(this);
    this.closeActionsMenu = this.closeActionsMenu.bind(this);
  }

  onMyAccount(evt, nav) {
    this.closeActionsMenu();
    nav('/my-account');
  }

  onChangePassword(evt, nav) {
    this.closeActionsMenu();
    nav('/change-password');
  }

  logout(evt, nav) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');

    sessionStorage.removeItem('approvalList');
    sessionStorage.removeItem('submissionList');
    sessionStorage.removeItem('submittedEmployers');
    sessionStorage.removeItem('pathname');

    this.closeActionsMenu();
    const loginUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/login`;
    console.log(loginUrl);
    window.location.assign(loginUrl);
  }

  openActionsMenu(event: React.MouseEvent<HTMLButtonElement>) {
    this.setState({ open: true, anchorEl: event.currentTarget });
  }

  closeActionsMenu() {
    this.setState({ open: false, anchorEl: null });
  }

  render() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      console.error('MobileMenu: user is invalid');
      return <></>;
    }
    const role = user.role || 'Recruiter';
    const isAdmin = role === 'Manager' || role === 'Administrator';
    const homeLink = '/home';
    const name = user?.username || '--';

  return <div className="mobile-menu">
      <a href={homeLink}><img className="mobile-logo" src={matchLogo} alt="Lateral Match logo" width="120" height="50" /></a>

      <Button
        id="mobile-menu-btn"
        aria-haspopup="true"
        aria-controls={this.state.open ? 'dropdown-menu' : undefined}
        aria-expanded={this.state.open ? 'true' : undefined}
        onClick={this.openActionsMenu}
      >
        <MenuIcon />
      </Button>

      <Menu
        id="dropdown-menu"
        anchorEl={this.state.anchorEl}
        open={this.state.open}
        onClose={this.closeActionsMenu}
        MenuListProps={{ 'aria-labelledby': 'mobile-menu-btn' }}
      >
        <MenuItem href="/home" component={Link} onClick={this.handleClose}>Home</MenuItem>
        <MenuItem href="/candidates" component={Link} onClick={this.handleClose}>Candidates</MenuItem>

        { isAdmin &&
        <MenuItem href="/recruiters" component={Link} onClick={this.handleClose}>Recruiters</MenuItem>
        }

        <MenuItem href="/employers" component={Link} onClick={this.handleClose}>Employers</MenuItem>

        { isAdmin &&
        <MenuItem href="/invoices" component={Link} onClick={this.handleClose}>Invoices</MenuItem>
        }

        <MenuItem href="/placed-candidates" component={Link} onClick={this.handleClose}>Placed</MenuItem>
        <MenuItem href="/exclusive" component={Link} onClick={this.handleClose}>Exclusive</MenuItem>
        <MenuItem href="/do-not-contact" component={Link} onClick={this.handleClose}>Do Not Contact</MenuItem>

        <Divider/>

        <FirmProspectsMenuItem />
        <WebsiteMenuItem />
        <MyAccountMenuItem onClick={this.onMyAccount} />
        <ChangePasswordMenuItem onClick={this.onChangePassword} />
        <LogoutMenuItem onClick={this.logout} name={name} />
      </Menu>
    </div>;
  }
}

